import { formatDisplayPrice } from '../../../../../../../utils/math/formatDisplayPrice';

export function parseBreakNotificationDetails(notification) {
  const setupString = 'Break';
  return {
    tactic: setupString,
    price: formatDisplayPrice(notification.statusDetails.triggerPrice),
  };
}
